/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rcorners1[_ngcontent-%COMP%]{border-radius:25px;padding:20px;background:var(--background-tertiary)!important;background-color:var(--background-tertiary)!important;color:var(--foreground-tertiary)!important}"];
export { styles as styles };
